export class PostcodeLookup {
    constructor(options) {
        this.target = false;
        this.targetJq = false;
        this.lat = false;
        if (typeof customerLat !== 'undefined') {
            this.setLat(customerLat);
        }
        this.lng = false;
        if (typeof customerLng !== 'undefined') {
            this.setLng(customerLng);
        }
        this.stringsToLookup = [];
        this.waitingForGeocoder = false;
        this.onUpdate = false;
        this.onSortDealers = false;
        this.dealers = [];
        this.brand = false;
        this.filters = {
            brand: false,
            new: false,
            used: false,
            service: false,
            parts: false,
            business: false,
        };
        this.filterElement = false;

        // If no options passed in, just exit
        if (typeof options == 'undefined') {
            return false;
        }
        // If a target is passed in and it's a valid querySelector, use it as the target
        if (typeof options.target !== 'undefined' && document.querySelector(options.target)) {
            this.target = document.querySelector(options.target);
            this.targetJq = $(this.target);
        }
        // If a dealer list is passed in, use it
        if (typeof options.dealers !== 'undefined') {
            this.dealers = options.dealers;
        }
        // If a callback function was passed in for onUpdate or onSortDealers, use it
        if (typeof options.onUpdate !== 'undefined') {
            this.onUpdate = options.onUpdate;
        }
        if (typeof options.onSortDealers !== 'undefined') {
            this.onSortDealers = options.onSortDealers;
        }

        if (typeof options.filters !== 'undefined') {
            this.setFilters(options.filters);
        }

        this.attachEvents();
        this.populateCustomerData();
    }

    cleanseNumber(n) {
        if (typeof n == 'number') {
            return n;
        }

        if (typeof n == 'string') {
            return parseFloat(n.replace(/[^\d.-]/g, ''));
        }

        return 0;
    }

    calculateDistance(lat2, lng2) {
        let dLat = 0;
        let dLon = 0;
        let dlat1 = 0;
        let dlat2 = 0;
        let a = 0;

        lat2 = this.cleanseNumber(lat2);
        lng2 = this.cleanseNumber(lng2);

        if (this.lat == 0 ||
            lat2 == 0 ||
            this.lat - lat2 == 0 ||
            this.lng - lng2 == 0) {
            return 0;
        }

        dLat = Math.PI / 180 * (this.lat - lat2);
        dLon = Math.PI / 180 * (this.lng - lng2);
        dlat1 = Math.PI / 180 * (lat2);
        dlat2 = Math.PI / 180 * (this.lat);

        if (dLat == 0 ||
            dLon == 0) {
            return 0;
        }

        a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(dlat1) * Math.cos(dlat2);
        return (6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) * 0.6214;
    }

    setLat(lat) {
        this.lat = this.cleanseNumber(lat);
    }

    setLng(lng) {
        this.lng = this.cleanseNumber(lng);
    }

    sortDealersWithLatLng(callbackFunction) {
        let self = this;
        // Take a copy of the base dealers list
        let dealers = this.dealers;
        // Filter the dealers by the filters on the filter element
        let filters = this.getFilters();
        dealers = dealers.filter(function (location) {
            return this.filterLocation(filters, location);
        }.bind(this));

        // If the lat/lng isn't valid, just use the filtered list
        if (this.lat == false && this.lng == false) {
            callbackFunction(dealers);
            if (this.onSortDealers !== false) {
                this.onSortDealers(dealers);
            }
            return false;
        }

        // Update the distance property of each dealer
        $.each(dealers, function (index, location) {
            dealers[index].distance = this.calculateDistance(location.lat, location.lng);
            dealers[index].nearest = false;
        }.bind(this));

        // Sort the list by the distance property
        dealers.sort(function (a, b) {
            if (a.distance < b.distance) {
                return -1;
            }
            if (a.distance > b.distance) {
                return 1;
            }
            return 0;
        });

        // If the list isn't somehow empty, set the first item as nearest
        if (typeof dealers[0] !== 'undefined') {
            dealers[0].nearest = true;
        }

        // Call the callback we were passed in
        callbackFunction(dealers);
        if (this.onSortDealers !== false) {
            this.onSortDealers(dealers);
        }
        return true;
    }

    /**
     * Accepts a postcode and attempts to match it to a known UK Postcode format
     * If a match is found, the postcode is rebuilt into a strict format with the correct number of spaces
     *
     * @param {string} postcode
     */
    cleansePostcode(postcode) {
        let output = '';
        let pattern = /^([A-Za-z])([0-9])[ ]*([0-9])([A-Za-z])([A-Za-z])[ ]*$/;
        let result = postcode.match(pattern);
        if (result) {
            output = result[1] + result[2] + ' ' + result[3] + result[4] + result[5];
            return output.toUpperCase();
        }

        pattern = /^([A-Za-z])([0-9])([0-9])[ ]*([0-9])([A-Za-z])([A-Za-z])[ ]*$/;
        result = postcode.match(pattern);
        if (result) {
            output = result[1] + result[2] + result[3] + ' ' + result[4] + result[5] + result[6];
            return output.toUpperCase();
        }

        pattern = /^([A-Za-z])([A-Za-z])([0-9])[ ]*([0-9])([A-Za-z])([A-Za-z])[ ]*$/;
        result = postcode.match(pattern);
        if (result) {
            output = result[1] + result[2] + result[3] + ' ' + result[4] + result[5] + result[6];
            return output.toUpperCase();
        }

        pattern = /^([A-Za-z])([A-Za-z])([0-9])([0-9])[ ]*([0-9])([A-Za-z])([A-Za-z])[ ]*$/;
        result = postcode.match(pattern);
        if (result) {
            output = result[1] + result[2] + result[3] + result[4] + ' ' + result[5] + result[6] + result[7];
            return output.toUpperCase();
        }

        pattern = /^([A-Za-z])([0-9])([A-Za-z])[ ]*([0-9])([A-Za-z])([A-Za-z])[ ]*$/;
        result = postcode.match(pattern);
        if (result) {
            output = result[1] + result[2] + result[3] + ' ' + result[4] + result[5] + result[6];
            return output.toUpperCase();
        }

        pattern = /^([A-Za-z])([A-Za-z])([0-9])([A-Za-z])[ ]*([0-9])([A-Za-z])([A-Za-z])[ ]*$/;
        result = postcode.match(pattern);
        if (result) {
            output = result[1] + result[2] + result[3] + result[4] + ' ' + result[5] + result[6] + result[7];
            return output.toUpperCase();
        }

        return output;
    }

    async lookupLocationFromString(callbackFunction) {
        // If there's nothing in the list of strings to lookup, then don't bother going further
        if (this.waitingForGeocoder || this.stringsToLookup.length == 0) {
            return false;
        }
        // Pop the most recent string from the list of inputs from the customer
        // And convert it to a valid UK postcode
        let locationString = this.cleansePostcode(this.stringsToLookup[this.stringsToLookup.length - 1]);
        // If the string is empty, then don't bother looking up
        // Invalid UK postcodes get set to empty
        if (locationString == '' || typeof locationString == 'undefined') {
            return false;
        }
        // Empty the rest of the strings to lookup
        this.stringsToLookup = [];
        this.waitingForGeocoder = true;
        // Add the class to indicate work is being done
        this.targetJq.find("[data-customer-postcode]").addClass('input-processing');
        let self = this;
        // Submit the geocode request to Google
        const googleClass = await GoogleMapsLoader.getMap();
        const geocoder = new googleClass.maps.Geocoder();
        geocoder.geocode({
            'address': locationString,
            componentRestrictions: {
                country: 'GB',
            }
        },
        function (results, status) {
            self.waitingForGeocoder = false;
            // If the strings to lookup has changed since we started this geocode process
            // Then recurse back into this function to lookup the most recent valid input
            if (self.stringsToLookup.length > 0) {
                self.lookupLocationFromString(callbackFunction);
                return false;
            }
            if (status == googleClass.maps.GeocoderStatus.OK) {
                // These are global vars that might be in use on the site somewhere still
                self.setLat(results[0].geometry.location.lat());
                self.setLng(results[0].geometry.location.lng());
                customerLat = self.lat;
                customerLng = self.lng;
                customerPostcode = locationString;

                Cookies.set('lat', self.lat);
                Cookies.set('lng', self.lng);
                Cookies.set('postcode', customerPostcode);

                // If any location update callback was added, call it now with the lookup details
                if (self.onUpdate !== false) {
                    self.onUpdate({ postcode: customerPostcode, lat: customerLat, lng: customerLng });
                }

                // Sort the dealers with the new lat/lng
                self.sortDealersWithLatLng(callbackFunction);
                // Remove the input processing flag as we finished successfully
                self.targetJq.find("[data-customer-postcode]").removeClass('input-processing');
            }
        });
    }

    /**
     * Sets the brand to a new value
     *
     * @param {string} newBrand
     */
    updateBrand(newBrand) {
        this.brand = newBrand;
        this.populateDealers();
    }

    /**
     * Sets the filters to be used if explicit HTML attributes aren't being used
     *
     * @param {Object} options
     */
    setFilters(options) {
        if (typeof options == 'undefined') {
            return this.filters;
        }
        this.filters.brand = ((typeof options.brand !== 'undefined') ? options.brand : this.filters.brand);
        this.filters.new = ((typeof options.new !== 'undefined') ? options.new : this.filters.new);
        this.filters.used = ((typeof options.used !== 'undefined') ? options.used : this.filters.used);
        this.filters.service = ((typeof options.service !== 'undefined') ? options.service : this.filters.service);
        this.filters.parts = ((typeof options.parts !== 'undefined') ? options.parts : this.filters.parts);
        this.filters.business = ((typeof options.business !== 'undefined') ? options.business : this.filters.business);
        return this.filters;
    }

    /**
     * Gets a filter object from the filter element, if it's set
     */
    getFilters() {
        let filters = this.filters;
        filters.brand = ((this.brand !== false) ? this.brand : filters.brand);

        // If we don't have a filter element, then exit here
        if (this.filterElement == false) {
            return filters;
        }

        // If we don't have a specific brand set directly on this class
        if (this.brand !== false) {
            // And a data-brand is specified on the filter element
            // Then use the global brand value of the page
            if (this.filterElement.attr('data-brand') && typeof brand !== 'undefined' && brand !== '') {
                filters.brand = brand;
            }
            // If a specific data-use-brand value is set then use that value
            else if (this.filterElement.attr('data-use-brand')) {
                filters.brand = this.filterElement.attr('data-use-brand');
                if (filters.brand == '') {
                    filters.brand = false;
                }
            }
        }
        if (this.filterElement.attr('data-new')) {
            filters.new = true;
        }
        if (this.filterElement.attr('data-used')) {
            filters.used = true;
        }
        if (this.filterElement.attr('data-service')) {
            filters.service = true;
        }
        if (this.filterElement.attr('data-parts')) {
            filters.parts = true;
        }
        if (this.filterElement.attr('data-business')) {
            filters.business = true;
        }
        return filters;
    }

    /**
     * Returns true or false for a given filters object and location
     *
     * @param {Array} filters
     * @param {Object} location
     */
    filterLocation(filters, location) {
        if ((filters.parts && location.offers_parts == 'N') ||
            (filters.service && location.offers_servicing == 'N') ||
            (filters.used && location.offers_used == 'N') ||
            (filters.business && location.offers_business == 'N') ||
            (filters.new && location.offers_new == 'N')) {
            return false;
        }
        if (filters.brand !== false && location.brand !== '') {
            if (filters.brand == 'citroen-ds') {
                if (location.brand !== 'citroen' && location.brand !== 'ds') {
                    return false;
                }
            }
            else if (location.brand !== filters.brand) {
                return false;
            }
        }
        return true;
    }

    /**
     * Sets the element to use to get the filters to filter the dealer list
     *
     * @param {Element} element
     */
    setFilterElement(element) {
        this.filterElement = element;
    }

    /**
     * Binds events to the relevant inputs inside this.target
     */
    attachEvents() {
        let self = this;
        let element = false;

        // If there's a data-brand-element in the form, bind an event to update the brand we use
        element = this.targetJq.find('[data-brand-element]');
        if (element.length > 0) {
            element.off('change.CustomerLocationHandler').on('change.CustomerLocationHandler', function () {
                self.updateBrand($(this).val());
            });
        }

        // If there's a data-customer-location element, use it's value as a Postcode lookup
        element = this.targetJq.find('[data-customer-postcode]');
        if (element.length > 0) {
            element.off('focus.CustomerLocationHandler').on('focus.CustomerLocationHandler', function () {
                $(this).select();
            });

            // If the element has a data-location-target, and the value of it is a valid querySelector
            if (element.attr('data-location-target') && $(element.data('locationTarget')).length > 0) {
                this.setFilterElement($(element.attr('data-location-target')));
                // Bind the input event to perform the lookup and sort the dealers into the data-location-target
                element.off('input.CustomerLocationHandler').on('input.CustomerLocationHandler', function () {
                    // Push the current value onto the stack of inputs
                    self.stringsToLookup.push($(this).val());
                    self.lookupLocationFromString(
                        function (response) {
                            self.fillLocationTargetWithSortedLocations(locationTarget, response, false, true);
                        }
                    );
                });
            }
            else {
                this.setFilterElement(false);
                $(element).off('input.CustomerLocationHandler').on('input.CustomerLocationHandler', function () {
                    // Push the current value onto the stack of inputs
                    self.stringsToLookup.push($(this).val());
                    self.lookupLocationFromString(function (response) {});
                });
            }
        }
    }

    /**
     * Sets the initial value of the Postcode input if one is stored in the cookies
     */
    populateCustomerData() {
        let element = this.targetJq.find('[data-customer-postcode]');
        if (element.length > 0 && element.val() == '') {
            let customerPostcode = getCookieValue('postcode');
            element.val(customerPostcode);

            if (customerPostcode) {
                element.addClass('active'); // Fix label not moving
            }
        }
        if (element.val() !== '') {
            element.trigger('input.CustomerLocationHandler');
        }
    }

    populateDealers(){
        // Check if we have a dealer element to update
        let locationTarget = this.targetJq.find("[data-populate-dealers='true']");
        if (locationTarget.length > 0) {
            let self = this;
            let selectedLocation = false;
            if (locationTarget.attr('data-initial-location-id')) {
                selectedLocation = locationTarget.data('initialLocationId');
            }
            this.sortDealersWithLatLng(
                function(locations) {
                    this.fillLocationTargetWithSortedLocations(locations, selectedLocation, false);
                }.bind(this)
            );
            return true;
        }
        this.sortDealersWithLatLng(function(r) {});
        return false;
    }

    fillLocationTargetWithSortedLocations(locations, selectedLocation, customerInteractionEvent) {
        let locationTarget = this.targetJq.find("[data-populate-dealers='true']");
        if (locationTarget.length <= 0) {
            return false;
        }

        let defaultText = 'Please select your nearest dealer';
        if (locationTarget.data('noDefaultText')) {
            defaultText = '';
        }

        // Empty the locations select element
        locationTarget.empty().append('<option value="">' + defaultText + '</option>');
        $.each(locations, function (index, location) {
            let distanceWording = ' miles away';
            let newOption = false;
            if (typeof location.distance !== 'undefined' && location.distance >= 0) {
                if (location.distance == 1) {
                    distanceWording = ' mile away';
                }
                if (selectedLocation == false && typeof location.nearest !== 'undefined' && location.nearest == true || selectedLocation == location.id) {
                    newOption = $('<option value="' + location.id + '" selected>' + location.name + ' (' + number_format(location.distance, 0) + distanceWording + ')</option>');
                }
                else {
                    newOption = $('<option value="' + location.id + '">' + location.name + ' (' + number_format(location.distance, 0) + distanceWording + ')</option>');
                }
            }
            else {
                if (selectedLocation !== false && selectedLocation == location.id) {
                    newOption = $('<option value="' + location.id + '" selected>' + location.name + '</option>');
                }
                else {
                    newOption = $('<option value="' + location.id + '">' + location.name + '</option>');
                }
            }
            locationTarget.append(newOption);
        });

        if (customerInteractionEvent) {
            locationTarget.trigger('change');
            if (locationTarget.val() !== '') {
                locationTarget.addClass('active');
            }
            return true;
        }

        if (locationTarget.val() != '') {
            locationTarget.addClass('active');
        }

        locationTarget.trigger('change', ['do_not_validate']);
        return true;
    }
}